export function useUserFormValidation() {
  function validName(name: string): boolean {
    return name.trim().length >= 4
  }

  function validPassword(password: string): boolean {
    return /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(password)
  }

  function shouldValidatePassword(password: string): boolean {
    return password !== ''
  }

  return { validName, validPassword, shouldValidatePassword }
}
